import { useDispatch, useSelector, useStore } from 'react-redux';

import type { AppDispatch, AppStore, RootState } from './store';

/**
 * Pre-typed Redux hooks.
 *
 * Always use these instead of the untyped `useDispatch` / `useSelector`, so
 * thunk dispatch and state access are checked rather than inferred as `any`.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
